import { TYPES } from './actions';
import entity from './entity';
import { merge } from '../../../../utils/state';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ticket: null,
  isLoading: false,
  error: null,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    case TYPES.GET_TABLEAU_AUTH_REQUEST:
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.GET_TABLEAU_AUTH_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
        ticket: null,
      });
    case TYPES.GET_TABLEAU_AUTH_SUCCESS:
      return merge(state, {
        isLoading: false,
        ticket: action.payload,
        error: null,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
